module.exports = __webpack_public_path__ + "img/75677.c4909370.svg";